import { useState } from 'react'
import { Accordion } from '../../components/accordion'
import { SearchInput } from '../../components/inputs/searchInput'
import { NUMBER_OF_ITEMS_PER_PAGE } from '../../constants'
import { getPageFromSkip, getSkipFromPage } from '../../helpers'
import { useGetAllProductsQuery } from '../../redux-toolkits/products/products.slice'
import { ProductSearchQuery } from '../../redux-toolkits/products/products.type'
import ProductsTable from '../products/ProductsTable'

export const SingleVendorProducts = ({ creatorId }: { creatorId: string }) => {
  const [query, setQuery] = useState<ProductSearchQuery>({
    skip: 0,
    limit: NUMBER_OF_ITEMS_PER_PAGE,
  })

  const { data, isFetching, refetch } = useGetAllProductsQuery(
    { ...query, vendorId: creatorId },
    { skip: !creatorId, refetchOnMountOrArgChange: true },
  )

  return (
    <Accordion title="Products">
      <div className="flex flex-col gap-4 mt-4">
        <div className="w-full md:max-w-[400px]">
          <SearchInput
            searchFunction={(search) => {
              setQuery({ ...query, search: search || undefined, skip: 0 })
            }}
            placeholder="Search products"
          />
        </div>

        <ProductsTable
          productList={data?.data.data ?? []}
          fulfilmentCentres={[]}
          currentPage={Number(
            getPageFromSkip(
              query.skip ?? 0,
              query.limit ?? NUMBER_OF_ITEMS_PER_PAGE,
            ),
          )}
          totalDataCount={data?.data.totalItems ?? 0}
          pageLimit={NUMBER_OF_ITEMS_PER_PAGE}
          onPageChange={(page) => {
            setQuery({
              ...query,
              skip: getSkipFromPage(
                page,
                query.limit ?? NUMBER_OF_ITEMS_PER_PAGE,
              ),
            })
          }}
          loading={isFetching}
          refetch={refetch}
        />
      </div>
    </Accordion>
  )
}
